import type { InferType } from 'yup';
import { number, object, string } from 'yup';

export const customizeReferrerSchema = object({
  referrer: string().required(),
});

export const projectCreationStateSchema = object({
  preSelectedSpaceType: string().optional(),
});

export type CustomizeReferrerState = InferType<typeof customizeReferrerSchema>;

/**
 * Schema for location state passed to the customize route to determine where to
 * navigate back to on close and preserve scroll position from the previous
 * route to prevent interfering with the layout animation's positioning.
 */
export const customizeRouteStateSchema = customizeReferrerSchema.shape({
  page: object({
    offset: number().required(),
    height: number().required(),
  }),
});

export type CustomizeRouteState = InferType<typeof customizeRouteStateSchema>;

/**
 * Schema for location state passed *from* the customize route to the list views
 * to ensure that the customized image is scrolled into view in the list
 */
export const scrollToImageStateSchema = object({
  // Since this state is passed to a handful of routes, tag the state just to be
  // safe in case we use `aiGeneratedImageId` in any other location state
  tag: string()
    .oneOf(['scroll-to-image'] as const)
    .required(),
  aiGeneratedImageId: number().required(),
});

export type ScrollToImageState = InferType<typeof scrollToImageStateSchema>;

/**
 * Schema for location state passed to open the save to project toast when
 * navigating to a route
 *  */
export const saveToProjectSchema = object({
  // Since this state might be passed to a handful of routes, tag the state just
  // to be safe in case we use `aiDisplayImageId` in any other location state
  tag: string()
    .oneOf(['save-to-project'] as const)
    .required(),
  aiDisplayImageId: number().required(),
});

export type SaveToProjectState = InferType<typeof saveToProjectSchema>;
